export default class Loader {
    constructor($loader) {
        this.$loader = $loader;
        this.loading = this.loading.bind(this);
    }

    loading(loading) {
        clearTimeout(this.timeout);
        if(loading) {
            this.timeout = setTimeout(() => {
                this.$loader.classList.add('loader-overlay--active');
            }, 200)
        } else {
            this.$loader.classList.remove('loader-overlay--active');
        }
    }
}